/* eslint-disable import/no-unresolved */
import { Button } from "@mui/material";
import DetailsHeading from "src/shared/DetailsHeading";
import { useFormik } from "formik";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { setStepDetails } from "src/redux/Actions/common";
import { useState } from "react";
import CustomModal from "src/shared/CustomModal";
import { validationSchema } from "src/helpers/FormDetails/AssignmentClause";
import { setAssignmentClause } from "src/redux/Actions/assignmentClause";
import { updateExistingAssignmentDetails } from "src/services/AssignmentClauseDetails";
import { useMutation } from "react-query";
import CustomBackDrop from "src/shared/CustomBackDrop";
import AssignmentClause from "./AssignmentClause";
import { prepareAssignmentRequestBody } from "../../../helpers/FormDetails/AssignmentClause/resources";

function AssignmentClauseDetails() {
  const dispatch = useDispatch();
  const parentStepNumber = useAppSelector((state) => state.stepDetails.parentStepNo);
  const assignmentClauseDetails = useAppSelector((state) => state.assignmentClauseDetails);
  const proposalStatus = useAppSelector((state) => state.proposalStatus.status);
  const leadId = useAppSelector((state) => state?.common?.leadId);
  const [modalOpen, setModalOpen] = useState(false);
  const { mutate: updateAssignmentDetails, isLoading: isAssignmentSaving } = useMutation(
    updateExistingAssignmentDetails
  );
  const mefSchema = useAppSelector((state): any => state.masterdata_reducer?.mefJourneySchema);
  const assignmentMefFields = mefSchema?.assignmentNotice || {};

  const formik = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: assignmentClauseDetails!,
    validationSchema: validationSchema(assignmentMefFields),
    onSubmit: (fieldValues) => {
      if (proposalStatus !== "MEF Submitted") {
        const mapper = prepareAssignmentRequestBody(leadId, fieldValues);
        updateAssignmentDetails(
          {
            applicationId: assignmentClauseDetails.applicationId,
            reqBody: mapper
          },
          {
            onSuccess: (res: Record<string, any>) => {
              dispatch(setAssignmentClause({ ...fieldValues, applicationId: res?.data?.id }));
              dispatch(setStepDetails({ parentStepNo: parentStepNumber + 1, reviewStepNo: 1 }));
              window.scrollTo(0, 0);
            }
          }
        );
      }
    }
  });

  const handleBack = () => {
    dispatch(setStepDetails({ parentStepNo: parentStepNumber - 1 }));
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    if (!formik.isValid) {
      setModalOpen(true);
    }
    formik.handleSubmit();
  };

  return (
    <>
      <CustomBackDrop open={isAssignmentSaving} />
      <CustomModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      <div className="min-h-screen bg-whiteSmoke pt-8 pb-19.5">
        <div className="md:w-805/1000 mx-auto bg-white pt-8.5 pb-10 rounded-1.5xl">
          <div className="pr-10 pl-10.25">
            <DetailsHeading label="Assignment Notice" />
          </div>
          <div className="pl-10.25 bg-white pr-10 py-8 rounded-b-1.5xl">
            <AssignmentClause formik={formik} assignmentMefFields={assignmentMefFields} />
          </div>
          <div className="mt-10 flex justify-center">
            <Button
              variant="outlined"
              classes={{ outlined: "!rounded-lg" }}
              onClick={handleBack}
              className="!text-black !uppercase h-13 w-37.5 rounded-lg !mr-10"
            >
              Back
            </Button>
            <Button
              variant="contained"
              classes={{ contained: "!rounded-lg" }}
              onClick={handleNext}
              className="!uppercase h-13 w-37.5 rounded-lg"
            >
              NEXT
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignmentClauseDetails;
